<template>
<div class="col-md-12">
    <div class="row d-flex">
        <div class="my-1">
            <div class="row d-flex text-xs">
                <div class="col-lg-10 col-md-9 bg-main text-white text-center py-2">
                    <span class="fw-bold"> NOTA DE INGRESO URPA</span>
                </div>
                <div class="col-xl-2 col-lg-2 col-md-3 h-100 px-1">
            <button type="button" class="btn btn-outline-success w-100" :disabled="data.length == 0" @click="mtdViewPdf()">
              <i class="fas fa-file-pdf"></i> Exportar
            </button>
          </div>
            </div>
        </div>
        <div class="border border-1 p-3" v-if="data.length > 0">
            <!-- PAGINADO -->
            <div class="row d-flex justify-content-end mt-1">
                <div class="col-12 px-0">
                    <nav aria-label="Page navigation example" class="pagination-container">
                        <ul class="pagination pagination-xs justify-content-end">
                            <li class="page-item">
                                <a style="cursor: pointer" href="javascript:void(0)" class="page-link" @click="backPage">«</a>
                            </li>
                            <template>
                                <li class="page-item">
                                    <a class="page-link active" href="javascript:void(0)">PAG. {{ pos + 1  }} - {{notaIngreso.date_name}} {{ notaIngreso.hour }} </a>
                                </li>
                            </template>
                            <li class="page-item">
                                <a style="cursor: pointer" class="page-link" @click="nextPage">»</a>
                            </li>
                        </ul>
                    </nav>
                </div>
            </div>
            <div class="row d-flex mb-1">
                <div class="col-xl-3 col-sm-12  my-1 text-xs">
                    <div id="div-fi" class="form-group row d-flex align-left">
                        <div>
                            <span class="color-main fw-bold">DIAS HOSPITALIZADOS: </span>
                            <span>{{ notaIngreso.day }}</span>
                        </div>
                    </div>
                </div>
                <div class="col-xl-4 col-sm-12  my-1 text-xs">
                    <div id="div-medico" class="form-group row d-flex align-left">
                        <div>
                            <span class="color-main fw-bold">MEDICO: </span>
                            <span>{{ cpDoctor }}</span>
                        </div>
                    </div>
                </div>
            </div>
            <!-- SOA -->
            <div class="row d-flex">
                <div class="panel-border my-1">
                    <div class="row px-3 d-sm-flex ">
                        <div class="col-xs-12 col-xl-2 col-lg-6 col-md-12 mb-2">
                            <div class="row d-flex">
                                <span class="col-sm-12 color-main fw-bold">SIGNOS VITALES</span>
                                <div class="col-md-4 col-xl-12 col-lg-4 col-xs-6 mt-1 align-left" v-for="(item2, index) in signosVitales" :key="index">
                                    <div class="form-group row d-flex text-xs">
                                        <label :for="'inputsig' + index" class="col-sm-5 col-xl-5 color-main">{{ item2.label }}</label>
                                        <div class="col-xl-7 col-lg-7 col-xs-6">
                                            <input type="text" v-model="item2.value" disabled class="form-control form-control-input form-control-sm" :id="'inputsig' + index">
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-12 col-lg-6 col-xl-3 my-1">
                            <div id="div-subjective" class="form-group row align-left">
                                <label for="story" class="col-sm-12 col-md-12 color-main fw-bold">(S) SUBJETIVO</label>
                                <div class="col-xl-12 col-sm-12 col-md-12">
                                    <textarea rows="5" v-model="notaIngreso.subjective" class="form-control text-xs" aria-label="With textarea" id="story" disabled></textarea>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-12 col-xl-4 col-lg-6 my-1">
                            <div id="div-physical" class="form-group row d-flex align-left">
                                <span class="col-sm-12 color-main fw-bold ">(O) OBJETIVO</span>
                                <div class="col-xl-12 col-lg-6 col-md-6 col-xs-6 mt-1 align-left" v-for="(item2, index) in notaIngreso.physical_exam" :key="index">
                                    <div class="form-group row text-xs">
                                        <label :for="'input2' + index" class="col-xl-4 col-sm-12 color-main">{{ item2.label }}</label>
                                        <div class="col-xl-8 col-sm-12">
                                            <input type="text" v-model="item2.value" disabled class="form-control form-control-input form-control-sm" :id="'input2' + index">
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-12 col-xl-3 col-lg-6 my-1">
                            <div id="div-appreciation" class="form-group row align-left">
                                <label for="appreciation" class="col-sm-12 col-md-12 color-main fw-bold">(A) APRECIACION</label>
                                <div class="col-xl-12 col-sm-12 col-md-12">
                                    <textarea rows="5" v-model="notaIngreso.appreciation" class="form-control text-xs" aria-label="With textarea" id="story" disabled></textarea>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- PLAN Y GRAFICO (PENDIENTE) -->
            <div class="row d-flex">
                <div class="panel-border my-1">
                    <div class="row px-3 d-sm-flex ">
                        <div class="col-sm-12 col-xl-6 my-1">
                            <div id="div-plan" class="form-group row d-flex align-left">
                                <span class="col-sm-12 color-main fw-bold ">PLAN DE TRABAJO</span>
                                <div class="col-xl-12 col-sm-12">
                                    <ul class="list-group text-xs">
                                        <li class="list-group-item" v-for="(item, index) in notaIngreso.plan" :key="index">
                                            <span>{{ item.name }}</span>
                                        </li>
                                        <li class="list-group-item mb-2" v-if="notaIngreso.plan.length == 0">
                                            No se han registrado Planes
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-12 col-xl-6 my-1">
                            <div id="div-cie" class="form-group row d-flex align-left">
                                <span class="col-sm-12 color-main fw-bold ">DIAGNÓSTICOS</span>
                                <div class="col-xl-12 col-sm-12">
                                    <ul class="list-group text-xs">
                                        <li class="list-group-item" v-for="(item, index) in notaIngreso.diagnostics" :key="index">
                                            <span><b>{{ index + 1 }}</b>. {{ item.name }} - {{ item.codigo }}</span>
                                        </li>
                                        <li class="list-group-item mb-2" v-if="notaIngreso.diagnostics.length == 0">
                                            No se han registrado diagnosticos
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class=" border border-main p-5" v-else>
            <div class=" text-center">
                <h4>No hay evoluciones médicas registradas</h4>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import {
    mapActions
} from 'vuex';
import moment from "moment";
export default {
    name: 'c-medicalAct-sop-report-notaIngreso',
    data() {
        return {
            subpage: "buttons",
            pos: 0,
            notaIngreso: {},
            data: [],
        }
    },
    props: {
        medical_act_id: {
            type: Number,
            default: 0
        }
    },
    watch: {
        medical_act_id: {
            handler: function (newValue) {
                if (newValue !== 0) {
                    this.mtdViewNota();
                }
            },
            immediate: true
        },
        typeService: {
            handler: function (newValue) {
                this.pos = this.data.length - 1;
                this.notaIngreso = this.data[this.pos];
            },
            deep: true,
            immediate: true,
        }
    },
    computed: {
        cpDoctor() {
            return this.notaIngreso.doctor_name
        },
        signosVitales() {
            return this.notaIngreso.vital_sings;
        },

    },
    methods: {
        ...mapActions(['get', 'post']),
        mtdViewNota: function () {
            this.get({
                url: this.$store.getters.get__url + "/Sop/indexNotaUrpa/" + this.medical_act_id,
                token: this.$store.getters.get__token,
            }).then((response) => {
                if (response.statusCode === 200) {
                    let dataEvolutions = response.data;
                    this.data = [];
                    dataEvolutions.forEach(element => {
                        let evolutiondetails = {
                            doctor_name: element.doctor.name+" " + element.doctor.last_name,
                            date_name: element.datename,
                            id: element.id,
                            medical_act_id: element.medical_act_id,
                            date: element.date,
                            hour: element.hour,
                            day: element.day,
                            vital_sings: JSON.parse(element.vital_sings),
                            subjective: element.subjective,
                            physical_exam: JSON.parse(element.physical_exam),
                            current_analytics: JSON.parse(element.current_analytics),
                            appreciation: element.appreciation,
                            diagnostics: JSON.parse(element.diagnostics),
                            plan: JSON.parse(element.plan)
                        }
                        this.data.push(evolutiondetails)
                    });
                    this.pos = this.data.length - 1;
                    if (this.data.length > 0) {
                        this.backPage();
                    }

                }
            });
        },
        returnHome() {
            //window.location.reload();
            this.$emit('mtdChangePage', 'home');
        },
        mtdback(subpage) {
            this.$emit('mtdChangeSubPage', subpage);

        },
        nextPage: function () {
            this.pos = (this.pos == this.data.length - 1) ? this.pos : this.pos + 1
            this.notaIngreso = this.data[this.pos];
        },

        backPage: function () {
            this.pos = (this.pos == 0) ? this.pos : this.pos - 1
            this.notaIngreso = this.data[this.pos];

        },
        mtdViewPdf: function(){
            let ruta = `/viewpdfReportPatient/evolutions/6/${this.notaIngreso.medical_act_id}`;
            window.open(this.$store.getters.get__url + ruta, "_blank");
        }
    },
    filters: {
        formatDate(date) {
            return date != null ? moment(date).format("DD/MM/YYYY") : "-";
        },
        formatTime(time) {
            let arTime = time.split(":");
            if (arTime[0] <= 12) {
                return time + " am";
            } else {
                return arTime[0] - 12 + ":" + arTime[1] + " pm";
            }
        },
    },

}
</script>
